/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Icon from 'common/components/elements/icons';
import CircleLoader from 'common/components/elements/loader/circle';
import PreviewVideo from 'sites/views/media-modules/preview-video';

const Video = ({
   poster,
   src,
   isAutoPlay,
   setLoaded,
   imgLoad,
   setImgLoad,
   voiceIconRightPosition,
   voiceButtonClassName,
   isLockedForSFW,
   videoCustomThumbnailIsSfw,
}) => {
   return (
      <div
         className='w-full h-full bg-cover bg-center items-center justify-center flex relative'
      >
         {
            !isAutoPlay && (
               <>
                  <img
                     onLoad={ () => setImgLoad(false) }
                     src={ poster }
                     alt='thumbnail'
                     className='w-full object-cover h-full absolute inset-0'
                     style={ {
                        filter: videoCustomThumbnailIsSfw ? 'blur(32px)' : '',
                     } }
                  />
                  {
                     imgLoad && (
                        <div className='w-full h-full absolute inset-0 flex items-center justify-center'>
                           <CircleLoader color='major-dark' />
                        </div>
                     )
                  }
                  {
                     !imgLoad && (
                        <Icon name='play-filled' style={ { fontSize: '54px' } } color='major-dark' className='z-10' />
                     )
                  }
               </>
            )
         }
         {
            !!src && isAutoPlay && (
               <PreviewVideo
                  previewSrc={ src }
                  showVolumeButton={ true }
                  poster={ poster }
                  voiceIconRightPosition={ voiceIconRightPosition }
                  autoPlay={ isAutoPlay }
                  handelLoadedData={ () => setLoaded(true) }
                  videoClassName='object-cover'
                  voiceButtonClassName={ voiceButtonClassName }
                  isLockedForSFW={ isLockedForSFW }
               >
                  <>
                     <img
                        onLoad={ () => setImgLoad(false) }
                        src={ poster } alt='thumbnail' className='w-full object-cover h-full absolute inset-0 z-10'
                        style={ {
                           filter: videoCustomThumbnailIsSfw ? 'blur(32px)' : '',
                        } }
                     />
                  </>

               </PreviewVideo>
            )
         }
      </div>
   );
};

Video.propTypes = {
   poster: PropTypes.string,
   src: PropTypes.string,
   setLoaded: PropTypes.func,
   imgLoad: PropTypes.bool,
   setImgLoad: PropTypes.func,
   isAutoPlay: PropTypes.bool,
   voiceButtonClassName: PropTypes.string,
   voiceIconRightPosition: PropTypes.number,
   isLockedForSFW: PropTypes.bool,
   videoCustomThumbnailIsSfw: PropTypes.bool,
};

export default memo(Video);
